import React from 'react';
import AnimatedSection from './AnimatedSection';

const Skills = () => {
  const technicalSkills = [
    'JavaScript', 'React', 'Node.js', 'HTML5', 'CSS3', 
     'Git', 'MongoDB', 'REST API',
    'AWS', 'Java', 'C#', 'C'
  ];

  const professionalSkills = [
    'Agil Utveckling', 'Problem Lösning', 'Teamwork', 
    'Kommunikation', 'Projektledning', 'UX/UI Design',
    'Code Review', 'Testing'
  ];

  const languages = [
    { language: 'Svenska', level: 'Flytande' },
    { language: 'Engelska', level: 'Professionell' },
    { language: 'Arabiska', level: 'Modersmål' }
  ];

  return (
    <AnimatedSection id="skills" className="section section-light">
      <div className="container">
        <h2>Tekniska Färdigheter</h2>
        <div className="skills-grid">
          <div className="skill-category">
            <h3>Frontend & Backend</h3>
            <div className="skills-list">
              {technicalSkills.map((skill, index) => (
                <span key={index} className="skill-tag">{skill}</span>
              ))}
            </div>
          </div>
          
          <div className="skill-category">
            <h3>Professionella Färdigheter</h3>
            <div className="skills-list">
              {professionalSkills.map((skill, index) => (
                <span key={index} className="skill-tag">{skill}</span>
              ))}
            </div>
          </div>
          
          <div className="skill-category">
            <h3>Språk</h3>
            <div className="languages-list">
              {languages.map((lang, index) => (
                <div key={index} className="language-item">
                  <span className="language-name">{lang.language}</span>
                  <span className="language-level">{lang.level}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default Skills;